import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode } from "..";
import { dataFetchReducer } from './utils/dataFetchReducer';
import { getConfiguration } from './utils/configuration';

let source = null;

export function useFetchReservation(reservationCode) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
        newData: null
    });
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            if (source != null) {
                source.cancel();
            }
            source = axios.CancelToken.source();
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {cancelToken: source.token, params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.reloadReservation;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            token : '',
            reservationCode : reservationCode
        };
        fetchData(url, params, function(response) {
            dispatch({type: 'FETCH_SUCCESS', payload: JSON.parse(response.object)});
        });

        return () => {
            didCancel = true;
        };
    }, [reservationCode]);

    return [state, dispatch];
}
